<template>
  <div>
    <div class="founding" v-if="isMobile == 'pc'">
      <div class="founding-img" v-for="item in list" :key="item.id">
        <div class="founding-img-title">
          <h2>{{ $t(item.title) }}</h2>
        </div>
        <div class="founding-img-list">
          <el-row :gutter="40">
            <el-col :span="screenWidth<=540?12:8" v-for="imgItem in item.imgList" :key="imgItem.id">
              <div>
                <img :src="imgItem" alt="" style="width: 100%;" class="founding-img-list-item">
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="founding-mobile" v-if="isMobile == 'mobile'">
      <div class="founding-img" v-for="item in list" :key="item.id">
        <div class="founding-img-title">
          <h2>{{ $t(item.title) }}</h2>
        </div>
        <div class="founding-img-list">
          <el-row :gutter="40">
            <el-col :span="screenWidth<=540?12:8" v-for="imgItem in item.imgList" :key="imgItem.id">
              <div>
                <img :src="imgItem" alt="" style="width: 100%;" class="founding-img-list-item">
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { mapState } from 'vuex'
import { listInfo } from '@/api/index';
export default {
  computed: {
    ...mapState(['screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      list: [
        {
          title: 'FoundingInstitutionsFoundation',
          id: '1',
          imgList: []
        },
        {
          title: 'CouncilMembers',
          id: '2',
          imgList: []
        }
      ]
    };
  },
  mounted() {
	  //关于萨马兰奇体育发展基金会
	this.listFoundingSupportingInstitutionsOfTheFoundation();
	//基金会宗旨
	this.listCouncil()
  },
  methods: {
	  //获取基金会创始支持机构
	  listFoundingSupportingInstitutionsOfTheFoundation() {
	  		 const formData = new FormData();
	  		 formData.append("moduleId", 18);
	  		 listInfo(formData).then(res => {
	  		   if (res.data && res.data != null) {
				   for(var i =0;i<res.data.length;i++){
					   this.list[0].imgList.push(res.data[i].imgUrl);
				   }
	  		   }
	  		 })
	   },
	   
	   //理事单位
	   listCouncil() {
	   		 const formData = new FormData();
	   		 formData.append("moduleId", 19);
	   		 listInfo(formData).then(res => {
	  		   if (res.data && res.data != null) {
				   for(var i =0;i<res.data.length;i++){
					   this.list[1].imgList.push(res.data[i].imgUrl);
				   }
	  		   }
	   		 })
	    },
  }
};
</script>

<style lang="less" scoped>
.founding{
  margin-top: -2rem;
  .founding-img{
    margin: 0 auto;
    width: 60%;
    .founding-img-title{
      margin-top: 5rem;
      text-align: center;
    }
    .founding-img-list{
      margin-top: 3rem;
      .founding-img-list-item{
        background-color: white;
        width: 100%;
        box-sizing: border-box;
        border-radius: 0.3rem;
        margin-top: 2rem;
        box-shadow: 0px 0px 0.5rem rgb(211, 209, 209);
      }
    }
  }
}
.founding-mobile{
  // margin-top: -2rem;
  padding: 0 18px;
  .founding-img{
    // margin: 0 auto;
    // width: 80%;
    .founding-img-title{
      margin-top: 5rem;
      text-align: center;
    }
    .founding-img-list{
      margin-top: 3rem;
      .founding-img-list-item{
        background-color: white;
        width: 100%;
        box-sizing: border-box;
        border-radius: 0.3rem;
        margin-top: 2rem;
        box-shadow: 0px 0px 0.5rem rgb(211, 209, 209);
      }
    }
  }
}
</style>